import { render } from "./PageNavigation.vue?vue&type=template&id=1efbdfc6&scoped=true"
import script from "./PageNavigation.vue?vue&type=script&lang=js"
export * from "./PageNavigation.vue?vue&type=script&lang=js"

import "./PageNavigation.vue?vue&type=style&index=0&id=1efbdfc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efbdfc6"]])

export default __exports__